import { of } from 'rxjs';
import { map, switchMap, filter, takeWhile } from 'rxjs/operators';

import { GENERATE_EOD_MESSAGE_ID } from '../../services/pusher-service/pusher-contract-messages';
import { createPusherMessageCache } from './message-cache';

export const requestAndGetEODMessage = (curriedApi) => {
  const { findMessage } = createPusherMessageCache(GENERATE_EOD_MESSAGE_ID);

  return curriedApi().pipe(
    switchMap((response) => {
      const [jobGuid] = response;
      const messageChecker = (pusherMessage) => pusherMessage.messageGuid === jobGuid;

      return of({
        jobGuid,
        findMessage$: findMessage(messageChecker).pipe(
          filter((res) => res.data?.final === undefined || res.data?.final === true),
          takeWhile((res) => res.data?.final === undefined || res.data?.final === true, true),
          map((_response) => {
            const { data, messageGuid } = _response;
            const isOldMessage = data.final === undefined;
            const pusherData = isOldMessage ? data : data.message;
            return { pusherData, messageGuid };
          }),
        ),
      });
    }),
  );
};
